
import { Component, Vue, Prop } from "vue-property-decorator";
import UiButton from "@/components/button/ui-button.vue";
import RouteParams from "@/entities/RouteParams";
import CardImage from "@/components/common/CardImage.vue";
import DefaultCardImage from "@/components/card/DefaultCardImage.vue";
import CardRatingTalentMaping from "@/components/rating/CardRatingTalentMaping.vue";
import ToggleFavoriteTalentMapping from "@/components/favorite/ToggleFavoriteRequests.vue";
import { User, Contractor } from '@/generated/graphql';
import RouteNames from '@/entities/RouteNames';
import ToggleFavorite from "@/components/favorite/ToggleFavoriteRequests.vue";
import ContractorResendInvitation from "@/components/invite/ContractorResendInvitation.vue";
import InvitationSentTooltip from "@/components/invite/InvitationSentTooltip.vue";
import ContractorRating from "@/components/rating/ContractorRatingNew.vue";
import ResourceCards from "@/components/card/ResourceCards.vue";
import getLocationInfo from "@/helpers/locations/getLocationInfo";
import BadgeColor from "@/entities/BadgeColor";
import ChatIcon from "@/components/icons/ChatIconNew.vue";
import ChatIconHover from "@/components/icons/ChatIconHoverNew.vue";
import Contractor_PROJECTS from "@/apollo/contractors/GetContractorProjects.gql";
import Badge from "@/components/common/BadgeNew.vue";
import AddContractorToProject from "@/components/contractors/AddContractorToProject.vue";
import ActivityFormModal from "@/components/projects/activities/ActivityFormModal.vue";
import { emailStatusText, managerSuspendedText } from "@/data/userStatuses";
import ResourceAvatar from "@/components/card/ResourceAvatar.vue";
import ActionSection from "@/components/card/ActionSection.vue";
import EmployeeTag from "@/components/employee/EmployeeTagNew.vue";
import RemoveManagerContractorRequest from "@/components/contractors/RemoveManagerContractorRequestResources.vue";
import AddContractorToCompany from "@/components/contractors/AddContractorToCompanyNew.vue";

import CountryFlag from "vue-country-flag";
import getCountryCode from "@/utils/getCountryCode";


@Component({
  components: {
    UiButton,
    CardImage,
    DefaultCardImage,
    CardRatingTalentMaping,
    ToggleFavoriteTalentMapping,
    ResourceCards,
    CountryFlag,
    Badge,
    ResourceAvatar,
    ChatIconHover,
    ActionSection,
    ContractorRating,
    EmployeeTag,
    ActivityFormModal,
    ContractorResendInvitation,
    InvitationSentTooltip,
    ChatIcon,
    AddContractorToProject,
    ToggleFavorite,
    RemoveManagerContractorRequest,
    AddContractorToCompany,
  },
})
export default class ContractorLocationCardToLoopV2 extends Vue {
  @Prop({ type: Object, required: true }) readonly contractor!: Contractor;
  @Prop({ type: Object, required: true, default: {} }) readonly user!: User;
  @Prop({ type: Object, required: true }) readonly ratingTotal!: {};
  @Prop({ type: Number, required: true }) readonly items!: Number;
  @Prop({ type: Number, required: false, default: null }) readonly ratingUnit!: Number;
  @Prop({ type: Object, required: true }) readonly employeePageRouteParams!: RouteParams<{ id: string }>;
  @Prop({ type: String, required: true }) readonly employeeUserId!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly firstSkill!: string;
  @Prop({ type: String, required: true }) readonly secondSkill!: string;
  @Prop({ type: String, required: true }) readonly country!: string;
  @Prop({ type: String, required: true }) readonly city!: string;
  @Prop({ type: String, required: true }) readonly jobTitle!: string;
  @Prop({ type: String, required: true }) readonly companyName!: string;
  @Prop({ type: Number, required: true, default: 0 }) readonly ratingCount!: number;
  @Prop({ type: String, required: true, default: null }) readonly maxmin!: {min: number, max: number};
  @Prop({ type: Array, required: true }) readonly skill!: [];
  @Prop({ type: Array, required: true }) readonly favoritedByUsers!: [];
    isHoveredChat: boolean = false;
  	BadgeColor: typeof BadgeColor = BadgeColor;
  emailStatusText: string = emailStatusText;
  isGreaterThanOne = false;
  openEmployeePage(): void {
      this.$router.push(this.employeePageRouteParams);
    }
onUpdateToggleCard(favoriteId){
  this.$emit('cardDataUpdated',favoriteId)
}

    	get managerAvatar(): string | undefined {
		return this.user.avatar || undefined;
	}
  get managerLocation(): string {
    return `${this.city?.charAt(0).toUpperCase() + this.city?.slice(1)}, ${this.country?.charAt(0).toUpperCase() + this.country?.slice(1)}`
  }
  get capitalizedManagerLocation(): string {
    if (!this.managerLocation) return '';
    return this.managerLocation.charAt(0).toUpperCase() + this.managerLocation.slice(1);
  }
	get isEmailUnconfirmed(): boolean {
		return !this.user.confirmed;
	}
	get FullName(): string {
		return `${this.user.given_name} ${this.user.family_name}`;
	}
  	get isCardDisabled(): boolean {
		return this.isEmailUnconfirmed;
	}

  	get managerInitials(): string {
		return `${this.user.given_name![0]}${
			this.user.family_name![0]
		}`;
	}

	get contractorPageRoute(): RouteParams<{ id: string }> {
		// TODO: Needs to see if it is needed
		// if (this.contractorDetailsPageRoute) {
		//   return this.contractorDetailsPageRoute;
		// }
    return this.employeePageRouteParams
// this.$router.push(this.employeePageRouteParams);
// 		return {
// 			name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
// 			params: {
// 				id: this.user.id,
// 			},
// 		};
	}
    message(): void {
      this.$router.push({
        name: "inbox",
        query: {
          recipientUserId: this.employeeUserId,
        },
      });
    }

    mounted() {
    if (this.skill.length > 2) {
      this.isGreaterThanOne = true;
    }

    this.$watch('skill', (newSkill: string, oldSkill: string) => {
      if (newSkill.length > 2) {
        this.isGreaterThanOne = true;
      } else {
        this.isGreaterThanOne = false;
      }
    });
  }


}
